<div class="h-[90vh] w-full flex flex-col items-center">
  @if (!isAuthenticated) {
    <div
      class="p-4 text-center bg-gray-100 w-full max-w-[1024px] rounded-md shadow-sm mb-2"
      >
      <span class="text-gray-700">
        Nachrichten ohne Login:
        <span class="font-semibold" [class.text-red-500]="remainingMessages <= 1">
          {{ remainingMessages }}
        </span>
        / {{ totalMessages }}
      </span>
    </div>
  }

  <div class="relative w-full h-full max-w-[1024px]">
    <iframe [src]="url" class="w-full h-full"> </iframe>
    @if (!hasAccessToChat) {
      <div
        class="absolute inset-0 bg-gray-500/50 flex items-center justify-center"
        >
        <div class="bg-white p-6 rounded-lg shadow-lg text-center">
          <p class="text-lg">
            <a
              tabindex="0"
              role="button"
              class="hover:cursor-pointer"
              (click)="login()"
              (keyup.enter)="login()"
              >
              Anmelden</a
              >
              um kostenlos weiter mit sondisa zu chatten.
            </p>
          </div>
        </div>
      }
    </div>
  </div>
